import * as React from 'react'
const Svg = () => (
  <svg width={160} height={153} viewBox="0 0 160 153" fill="none">
    <g clipPath="url(#a)">
      <rect
        width={198.011}
        height={125.731}
        fill="url(#b)"
        rx={9.111}
        transform="scale(1 -1) rotate(15 596.191 47.239)"
      />
      <rect
        width={26.422}
        height={21.259}
        x={16.736}
        y={40.913}
        fill="#fff"
        opacity={0.5}
        rx={2.43}
        transform="rotate(-15 16.736 40.913)"
      />
      <path
        stroke="#fff"
        strokeWidth={1.215}
        d="M22.604 42.166s3.06-2.342 3.984 1.107c.924 3.448-3.225 3.255-3.225 3.255m0 0-4.779 1.28m4.779-1.28L24.72 51.6m0 0-4.778 1.28m4.778-1.28s4.97-1.331 5.458 2.016c.487 3.348-2.543 3.508-2.543 3.508M41.325 51.913s-3.147 2.423-4.124-.984c-.976-3.406 3.312-3.336 3.312-3.336m0 0 4.93-1.416m-4.93 1.416-1.436-5.009m0 0 4.93-1.416m-4.93 1.416s-5.126 1.473-5.651-1.846c-.525-3.319 2.605-3.568 2.605-3.568"
      />
      <path
        fill="#fff"
        d="m43.004 126.517 1.83 6.827-.827.222-1.597-5.961-.04.011-1.37 1.553-.225-.84 1.403-1.59.826-.222Zm3.793 6.301-.16-.6 1.592-3.071c.187-.359.337-.669.451-.928.114-.261.186-.498.218-.709a1.522 1.522 0 0 0-.034-.634 1.149 1.149 0 0 0-.34-.577 1.16 1.16 0 0 0-.576-.281 1.561 1.561 0 0 0-.705.035 1.43 1.43 0 0 0-.643.348 1.16 1.16 0 0 0-.33.57c-.053.221-.044.462.026.722l-.787.211a2.054 2.054 0 0 1-.006-1.128c.104-.351.292-.654.564-.908a2.352 2.352 0 0 1 1.01-.542c.4-.107.776-.118 1.13-.032.355.087.658.249.91.489.253.24.426.535.52.886.067.251.088.509.06.774-.024.261-.109.568-.252.921-.142.35-.353.788-.631 1.313l-1.094 2.051.014.053 3.173-.85.197.733-4.307 1.154Zm8.016-2.048a3 3 0 0 1-1.238.089 2.09 2.09 0 0 1-.985-.411 1.756 1.756 0 0 1-.58-.856l.84-.225c.077.215.203.385.38.509.175.122.382.198.621.227.239.028.49.008.752-.062.293-.079.54-.2.739-.363.199-.163.339-.353.419-.569a1.11 1.11 0 0 0 .023-.686 1.231 1.231 0 0 0-.364-.613 1.283 1.283 0 0 0-.668-.307c-.27-.044-.577-.02-.924.073l-.547.146-.196-.733.547-.147a1.68 1.68 0 0 0 .674-.338 1.147 1.147 0 0 0 .381-1.216 1.195 1.195 0 0 0-.315-.563 1.096 1.096 0 0 0-.54-.284 1.458 1.458 0 0 0-.693.032 1.776 1.776 0 0 0-.631.309c-.184.14-.32.308-.408.506a.997.997 0 0 0-.058.637l-.8.214a1.684 1.684 0 0 1 .072-1.027c.13-.325.337-.607.623-.846.289-.239.63-.411 1.023-.517.422-.113.807-.124 1.155-.034.348.088.64.249.877.483.236.235.398.513.484.835.103.385.09.74-.04 1.065-.127.325-.349.585-.665.782l.014.053c.45-.044.836.049 1.157.28.321.228.54.559.656.992.1.372.087.732-.036 1.082a2.134 2.134 0 0 1-.634.913 2.753 2.753 0 0 1-1.115.57Zm3.11-2.434-.183-.68 1.729-5.551.493-.132.282 1.054-.333.089-1.306 4.194.015.054 4.04-1.083.196.733-4.933 1.322Zm3.588.539-.43-1.606-.085-.317-1.314-4.904.787-.21 1.829 6.827-.787.21Zm6.13-4.843-.34-1.481-1.03 1.119-.47-.475 1.125-1.03-1.489-.33.17-.645 1.45.454-.445-1.452.64-.172.34 1.481 1.029-1.119.47.474-1.125 1.031 1.489.329-.17.646-1.45-.454.446 1.452-.64.172Zm4.693-1.258-.34-1.481-1.029 1.119-.47-.474 1.125-1.03-1.49-.33.17-.646 1.451.454-.446-1.452.64-.172.34 1.481 1.03-1.119.47.475-1.125 1.03 1.489.33-.17.646-1.451-.455.446 1.453-.64.171Zm4.694-1.258-.34-1.481-1.03 1.119-.47-.474 1.125-1.03-1.489-.33.17-.646 1.451.455-.446-1.453.64-.171.34 1.481 1.029-1.119.47.474-1.125 1.03 1.49.33-.17.646-1.452-.454.447 1.452-.64.171Zm4.693-1.257-.34-1.481-1.029 1.119-.47-.475 1.125-1.03-1.49-.33.17-.645 1.452.454-.447-1.452.64-.172.34 1.481 1.03-1.119.47.474-1.125 1.031 1.489.33-.17.645-1.451-.454.446 1.452-.64.172Zm7.334-1.965-.34-1.481-1.029 1.119-.47-.475 1.125-1.03-1.49-.33.17-.645 1.451.454-.446-1.452.64-.172.34 1.481 1.03-1.119.47.474-1.125 1.031 1.489.329-.17.646-1.451-.454.446 1.452-.64.172Zm4.694-1.258-.34-1.481-1.03 1.119-.47-.474 1.125-1.03-1.489-.33.17-.646 1.451.454-.446-1.452.64-.172.34 1.481 1.029-1.119.47.475-1.125 1.03 1.49.33-.17.646-1.452-.455.447 1.453-.64.171Zm4.693-1.258-.34-1.481-1.029 1.119-.47-.474 1.125-1.03-1.49-.33.17-.646 1.452.455-.447-1.453.64-.171.34 1.481 1.03-1.119.47.474-1.125 1.03 1.489.33-.17.646-1.451-.454.446 1.452-.64.171Zm4.694-1.257-.34-1.481-1.029 1.119-.47-.475 1.124-1.03-1.489-.33.17-.645 1.451.454-.446-1.452.64-.172.34 1.481 1.029-1.119.47.474-1.125 1.031 1.489.33-.17.645-1.45-.454.446 1.452-.64.172Zm7.334-1.965-.34-1.481-1.029 1.119-.47-.475 1.124-1.03-1.489-.33.17-.645 1.451.454-.446-1.452.64-.172.339 1.481 1.03-1.119.47.474-1.125 1.031 1.489.329-.17.646-1.451-.454.447 1.452-.64.172Zm4.693-1.258-.339-1.481-1.03 1.119-.47-.474 1.125-1.03-1.489-.33.17-.646 1.451.454-.447-1.452.64-.172.34 1.481 1.029-1.119.47.475-1.124 1.03 1.489.33-.17.646-1.451-.455.446 1.453-.64.171Zm4.694-1.258-.34-1.481-1.029 1.119-.47-.474 1.124-1.03-1.489-.33.17-.646 1.451.455-.446-1.453.64-.171.34 1.481 1.029-1.119.47.474-1.125 1.03 1.489.33-.17.646-1.451-.454.447 1.452-.64.171Zm4.693-1.257-.339-1.481-1.03 1.119-.47-.475 1.125-1.03-1.489-.33.17-.645 1.451.454-.447-1.452.64-.172.34 1.481 1.029-1.119.47.474-1.124 1.031 1.489.33-.17.645-1.451-.454.446 1.452-.64.172Z"
      />
      <g filter="url(#c)" opacity={0.5}>
        <circle
          cx={209.3}
          cy={93.072}
          r={23.081}
          fill="#4547B1"
          transform="rotate(-15 209.3 93.072)"
        />
      </g>
      <path
        stroke="#D4DDEB"
        strokeWidth={0.911}
        d="M108.696-6.68c3.588 22.155 24.393 65.05 78.916 60.165m0 0c.232-.02.465-.042.699-.065 55.044-5.316 22.469-2.172-.699.065Z"
        opacity={0.7}
      />
      <path
        stroke="#D4DDEB"
        strokeWidth={0.911}
        d="M83.62 7.858c14.224 17.36 53.749 44.018 98.454 12.425m0 0 .572-.407c44.938-32.227 18.343-13.156-.572.407Z"
        opacity={0.6}
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={99.005}
        x2={99.005}
        y1={0}
        y2={125.731}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3879F0" />
        <stop offset={1} stopColor="#428EFF" />
      </linearGradient>
      <clipPath id="a">
        <rect
          width={198.011}
          height={125.731}
          fill="#fff"
          rx={9.111}
          transform="scale(1 -1) rotate(15 596.191 47.239)"
        />
      </clipPath>
      <filter
        id="c"
        width={112.987}
        height={112.987}
        x={152.806}
        y={36.578}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_2587_10900" stdDeviation={16.703} />
      </filter>
    </defs>
  </svg>
)
export default Svg
